var Handlebars = require('/Users/ben/Code/honeybadger/public-uptime/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "Not found";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/not_found.hbs
// module id = 150
// module chunks = 0